import { useEffect, useState } from 'react';
import { getDashboardStats } from '../../services/dashboardService';
import { getErrorMessage } from '../../api/client';

const statCards = [
  { key: 'total_applicants', label: 'Total Applicants' },
  { key: 'active', label: 'Active' },
  { key: 'payment_pending', label: 'Payment Pending' },
  { key: 'rejected', label: 'Rejected' },
  { key: 'paid_count', label: 'Paid' },
  { key: 'refunds', label: 'Refunds' },
  { key: 'total_revenue_inr', label: 'Total Revenue (₹)', isCurrency: true },
  { key: 'registration_fee_inr', label: 'Registration Fee (₹)', isCurrency: true }
];

const DashboardTab = () => {
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const fetchStats = async () => {
      setIsLoading(true);
      setError('');
      try {
        const result = await getDashboardStats();
        if (isMounted) {
          setStats(result.data);
        }
      } catch (fetchError) {
        if (isMounted) {
          setError(getErrorMessage(fetchError, 'Unable to load dashboard stats.'));
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchStats();
    return () => {
      isMounted = false;
    };
  }, []);

  if (isLoading) {
    return <div className="theme-state text-center p-3">Loading dashboard...</div>;
  }

  if (error) {
    return <div className="theme-state theme-error text-center p-3">{error}</div>;
  }

  return (
    <div className="row g-3">
      {statCards.map((card) => (
        <div className="col-6 col-md-3" key={card.key}>
          <div className="theme-mini-card p-3 h-100 text-center">
            <span className="theme-meta-label d-block mb-2">{card.label}</span>
            <strong className="d-block text-white fs-4">
              {card.isCurrency ? `₹${Number(stats?.[card.key] || 0).toLocaleString('en-IN')}` : (stats?.[card.key] ?? 0)}
            </strong>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardTab;
